<div style="text-align:center" class="main" resize>
    <img src="../assets/fond_accueil.jpg" class="pic" alt="background" id="bgrnd" />
    <div class="welcome">
        <p class="skalaki">Skalaki</p>
        <button type="button" class="wire-btn enter-button" (click)="onEnter()">Enter</button>
        <div class="footer">
            <p (click)="updateText(skalaki1, updateTextTemplate)">{{skalaki1.text}}</p>
        </div>
    </div>
</div>

<ng-template #updateTextTemplate>
    <div class="modal-header">
        <h4 class="modal-title pull-left">Event</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <form #textForm="ngForm">
            <div class="form-group col-sm-12">
                <label for="text">Text</label>
                <textarea rows="18" class="form-control" required id="text" [(ngModel)]="textModel.text" name="text"
                    #text="ngModel"></textarea>
                <div *ngIf="text.invalid && (text.dirty || text.touched)" class="alert alert-danger">
                    Text is required
                </div>
            </div>
            <button type="button" class="btn btn-primary" (click)="modalRef.hide()">Cancel</button>
            <button type="button" class="btn btn-success pull-right" [disabled]="!textForm.form.valid"
                (click)="saveText()">Submit</button>
        </form>
    </div>
</ng-template>